// @flow

import { phoneInputCss } from '../../../css/phoneInput';

/**
 * Modern MUI v5 style definition with function-based approach
 * Each style is defined as a function that receives theme and returns style object
 */
const upgradePlanDialogStyles = {
  dialogCtr: (theme) => ({
    maxWidth: '100vw',
    width: 'auto',
    textAlign: 'center'
  }),
  
  flexContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    margin: theme.spacing(1)
  }),
  
  dialogHeader: (theme) => ({
    margin: theme.spacing(1)
  }),
  
  grow: (theme) => ({
    flexGrow: 1
  }),
  
  itemHeader: (theme) => ({
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    fontWeight: 600
  }),
  
  itemList: (theme) => ({
    '& p': {
      fontSize: '1rem',
      color: 'hsl(0,0%,80%)'
    }
  }),
  
  itemRow: (theme) => ({
    display: 'flex'
  }),
  
  itemDesc: (theme) => ({
    fontSize: '1rem',
    flexGrow: 1
  }),
  
  itemPrice: (theme) => ({
    fontSize: '1.2rem',
    color: theme.palette.primary.main,
    fontWeight: 600
  }),
  
  captionText: (theme) => ({
    fontSize: '1rem',
    color: 'hsl(0,0%,50%)'
  }),
  
  ccCaptionText: (theme) => ({
    marginTop: theme.spacing(2),
    fontSize: '1rem',
    color: 'hsl(0,0%,50%)'
  }),
  
  checkoutContentHeader: (theme) => ({
    marginBottom: theme.spacing(2)
  }),
  
  checkoutColCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'column'
  }),
  
  checkoutLineCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'row'
  }),
  
  bottomText: (theme) => ({
    marginBottom: theme.spacing(2)
  }),
  
  reviewSectionCtr: (theme) => ({
    minWidth: 300,
    maxWidth: 400,
    textAlign: 'left',
    marginLeft: theme.spacing(3.5),
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0
    },
    '& p': {
      fontSize: '1rem',
      justifyContent: 'left',
      alignItems: 'center',
      display: 'flex'
    },
    '& > div > p.price': {
      fontWeight: 700,
      marginTop: theme.spacing(1.5)
    },
    '& b': {
      color: theme.palette.primary.main
    }
  }),
  
  spaceTop: (theme) => ({
    marginTop: theme.spacing(2)
  }),
  
  pmRadioGroup: (theme) => ({}),
  
  pmListItem: (theme) => ({
    border: '1px solid #CCC',
    height: 65,
    cursor: 'pointer',
    '&:last-child': {
      borderTop: 0
    },
    '&:first-of-type': {
      border: '1px solid #CCC'
    }
  }),
  
  pmFormCtr: (theme) => ({
    width: '100%'
  }),
  
  reviewItemCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }),
  
  reviewItem: (theme) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    cursor: 'default'
  }),
  
  ctaBtnCtr: (theme) => ({
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      display: 'flex',
      justifyContent: 'end'
    }
  })
};

export default upgradePlanDialogStyles;
